import type { DataTableHeader } from '@/types/vuetify';

export function createWlTransactionPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        { title: t('wlTransaction.id'), value: 'id', key: 'id', align: 'start', sortable: true, nowrap: true },
        { title: t('wlTransaction.createdAt'), value: 'created_at', key: 'created_at', align: 'center', sortable: true, nowrap: true },
        {
            title: t('wlTransaction.processingStartedAt'),
            value: 'processing_started_at',
            key: 'processing_started_at',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        { title: t('wlTransaction.processedAt'), value: 'processed_at', key: 'processed_at', align: 'center', sortable: true, nowrap: true },
        { title: t('wlTransaction.type'), value: 'type_id', key: 'type_id', align: 'start', sortable: true, nowrap: true },
        { title: t('wlTransaction.operation'), value: 'operation_id', key: 'operation_id', align: 'start', sortable: true, nowrap: true },
        { title: t('wlTransaction.user'), value: 'tool_user_id', key: 'tool_user_id', align: 'start', sortable: true, nowrap: true },
        { title: t('wlTransaction.betInternalId'), value: 'bet_internal_id', key: 'bet_internal_id', align: 'start', sortable: true, nowrap: true },
        { title: t('wlTransaction.status'), value: 'status_id', key: 'status_id', align: 'center', sortable: true, nowrap: true },
        { title: t('wlTransaction.amount'), value: 'amount', key: 'amount', align: 'end', sortable: true, nowrap: true },
        { title: t('wlTransaction.availableBalance'), value: 'available_balance', key: 'available_balance', align: 'end', sortable: true, nowrap: true },
        { title: t('wlTransaction.description'), value: 'description', key: 'description', align: 'start', sortable: false, nowrap: true },
        { title: '', value: 'infoMenu', key: 'infoMenu', align: 'end', sortable: false, nowrap: true, width: 24, cellProps: { class: 'pl-0 pr-1' } },
    ];
}
